var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('b-navbar',{attrs:{"variant":"faded","type":"light"}},[_c('b-navbar-brand',{attrs:{"href":"#"}},[_vm._v("Diabets Kalkylator")])],1)],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }